import { render, staticRenderFns } from "./BufferInvoiceDetail.vue?vue&type=template&id=002314d2"
import script from "./BufferInvoiceDetail.vue?vue&type=script&lang=js"
export * from "./BufferInvoiceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports